// export const baseURL:string = "http://41.138.161.35:8084";

// const tokenModel = JSON.parse(localStorage.getItem('admin-auth') || '{}');
let token = "";
// if (tokenModel?.Token) {
//     token = tokenModel?.Token;
// }
const tokenModel = JSON.parse(localStorage.getItem("token") || "null");
if (tokenModel) {
  token = tokenModel;
}

export const baseURL: any = process.env.REACT_APP_BASE_URL?.slice(0, -4);

export const config: any = {
  Authorization: `Bearer ${token}`,
  Accept: "application/json",
  "X-XSS-Protection": "1; mode=block",
  "Content-Type": "application/json",
  "Cross-Origin-Embedder-Policy": "require-corp",
  "Content-Security-Policy":
    "script-src 'self' 'unsafe-inline' kit.fontawesome.com code.jquery.com cdn.jsdelivr.net embed.tawk.to static-v.tawk.to stackpath.bootstrapcdn.com cdn.datatables.net pharmmall.azurewebsites.net https://standard.paystack.co https://merchant-api.staging.cyberpay.ng",
  "X-Frame-Options": "SAMEORIGIN",
  "X-Content-Type-Options": "nosniff",
  "Strict-Transport-Security": "max-age=31536000",
  "Feature-Policy":
    "accelerometer 'none'; gyroscope 'none'; magnetometer 'none'; microphone 'none'; usb 'none'",
  "Cache-Control": "no-cache",
  "Cross-Origin-Opener-Policy": "same-origin",
  Pragma: "no-cache",
};

export const config2: any = {
  Authorization: `Bearer ${token}`,
  Accept: "application/json",
  "X-XSS-Protection": "1; mode=block",
  "Cross-Origin-Embedder-Policy": "require-corp",
  "Content-Security-Policy":
    "script-src 'self' 'unsafe-inline' kit.fontawesome.com code.jquery.com cdn.jsdelivr.net embed.tawk.to static-v.tawk.to stackpath.bootstrapcdn.com cdn.datatables.net pharmmall.azurewebsites.net https://standard.paystack.co https://merchant-api.staging.cyberpay.ng",
  "X-Frame-Options": "SAMEORIGIN",
  "X-Content-Type-Options": "nosniff",
  "Strict-Transport-Security": "max-age=31536000",
  "Feature-Policy":
    "accelerometer 'none'; gyroscope 'none'; magnetometer 'none'; microphone 'none'; usb 'none'",
  "Cache-Control": "no-cache",
  "Cross-Origin-Opener-Policy": "same-origin",
  Pragma: "no-cache",
};

export const apiRequest = async (
  url: any,
  method: string = "GET",
  body: any = {},
  config: any = { "Content-Type": "application/json" },
  download: boolean = false
) => {
  let res;
  let token = "";
  const tokenModel = JSON.parse(localStorage.getItem("token") || "null");

  if (tokenModel) {
    token = tokenModel;
  }
  
  const Authorization = `Bearer ${token}`;
  config.Authorization = Authorization;

  if (method.toLowerCase() === "get") {
    res = await fetch(`${baseURL}/${url}`, {
      method,
      headers: {
        ...config,
      },
    });
  } else {
    res = await fetch(`${baseURL}/${url}`, {
      method,
      headers: {
        ...config,
      },
      body,
    });
  }

  let data: any;
  if (download) {
    if (res.status == 200 && res.ok) {
      data = await res.blob();
    } else {
      data = await res.json();
    }
    return data;
  }
  data = await res.json();
  return data || res;
};

export const apiFormRequest = async (
  url: any,
  body: any,
  method: any = "POST"
) => {
  const config = config2;
  let res;
  const tokenModel = JSON.parse(localStorage.getItem("admin-auth") || "{}");
  let token = "";
  if (tokenModel?.Token) {
    token = tokenModel?.Token;
  }

  const Authorization = `Bearer ${token}`;
  config.Authorization = Authorization;
  res = await fetch(`${baseURL}/${url}`, {
    method,
    headers: {
      ...config,
    },
    body,
  });

  let data = await res.json();
  return data;
};
